<form [formGroup]="loginForm" (ngSubmit)="loginFormSubmit()" novalidate>
  <tc-form-group>
    <tc-input [prefixIcon]="'icofont-user-alt-7'" [placeholder]="'Login'" formControlName="login"></tc-input>
  </tc-form-group>

  <tc-form-group>
    <tc-input [prefixIcon]="'icofont-lock'" [placeholder]="'Password'" [type]="'password'" formControlName="pass"></tc-input>
  </tc-form-group>

  <!-- <tc-form-group>
    <tc-switcher [value]="true">Remember me</tc-switcher>
  </tc-form-group> -->

  <div class="actions justify-content-between">
    <!-- <button tc-button [view]="'accent'" [beforeIcon]="'icofont-login'">
      Login
    </button> -->
    <button tc-button >
      Login
    </button> 
  </div>
</form>
